/** Supabase Auth 客户端（仅用 @supabase/auth-js，轻量无多余依赖）。
 *
 * 配置从构建期环境变量读取：
 * - VITE_SUPABASE_URL
 * - VITE_SUPABASE_ANON_KEY
 * 本地开发可在 web/.env.local 里填；线上在 Cloudflare Pages 的
 * Environment variables 里配（Production + Preview 都要）。
 */
import { GoTrueClient } from '@supabase/auth-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined

export const SUPABASE_CONFIGURED = Boolean(url && anonKey)

let client: GoTrueClient | null = null

export function getSupabase(): GoTrueClient | null {
  if (!SUPABASE_CONFIGURED) return null
  if (!client) {
    client = new GoTrueClient({
      url: `${url!.replace(/\/+$/, '')}/auth/v1`,
      headers: { apikey: anonKey! },
      storageKey: 'unified-console-auth',
      autoRefreshToken: true,
      persistSession: true,
      // PKCE：OAuth 回调用 ?code= 换 token（auth-js 的 detectSessionInUrl
      // 默认开启，会在初始化时自动完成 exchangeCodeForSession）。implicit
      // flow 把 token 放在 #fragment 里，与 HashRouter 冲突。
      flowType: 'pkce',
    })
  }
  return client
}

/** 给 API 层用的同步 token 读取（localStorage，无 React 依赖）。 */
export function getAccessToken(): string | null {
  try {
    const raw = localStorage.getItem('unified-console-auth')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed?.access_token ?? null
  } catch {
    return null
  }
}

/** 拼到 fetch headers 里的 Authorization 头。 */
export function authHeader(): Record<string, string> {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
